import { render, staticRenderFns } from "./CatalogBranchAddress.vue?vue&type=template&id=bf38a8b6&scoped=true"
import script from "./CatalogBranchAddress.vue?vue&type=script&lang=js"
export * from "./CatalogBranchAddress.vue?vue&type=script&lang=js"
import style0 from "./CatalogBranchAddress.vue?vue&type=style&index=0&id=bf38a8b6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf38a8b6",
  null
  
)

export default component.exports